<template>
  <div class="cf-carousel__item">
    <div class="cf-card cf-flex cf-flex--column cf-flex--gap-16">
      <!-- Gift Card Design -->
      <cf-gift-card
        type="details"
        :card-design="giftCard.design"
      />

      <div class="cf-grid cf-grid--2-grid-column-equal">
        <!-- Gift Card Balance -->
        <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-12">
          <p class="cf-subtitle cf-subtitle--1">
            Balance
          </p>

          <h1 class="cf-title cf-title--1">
            {{ giftCardBalance }}
          </h1>
        </div>

        <!-- QR Code -->
        <div class="cf-qr-code-container">
          <vue-qrcode
            class="cf-image cf-image--auto-w cf-image--border"
            :value="giftCard.cardNumber"
            :scale="5"
          />
        </div>
      </div>

      <!-- Manage Card Button -->
      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        type="button"
        @click="$openModal('managePaymentMethodModal', { paymentMethod: giftCard })"
      >
        <span class="icon fa-cog" />

        Manage Card
      </button>
    </div>
  </div>
</template>


<script>
  import dollars from '@/filters/dollars';

  import CfGiftCard from '@/view/components/globals/cf-gift-card/index.vue';


  export default {
    name: 'GiftCardPaymentMethod',

    components: {
      CfGiftCard
    },

    props: {
      giftCard: {
        type: Object,
        required: true
      }
    },

    computed: {
      giftCardBalance() {
        return dollars(this.giftCard.balance);
      }
    }
  };
</script>
